module.exports = __webpack_public_path__ + "img/westudy_color.1a55df47.png";